import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Novo Email", -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_8 = { class: "accordion-item" }
const _hoisted_9 = {
  class: "accordion-header",
  id: "headingOne"
}
const _hoisted_10 = {
  class: "accordion-button",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseOne",
  "aria-expanded": "true",
  "aria-controls": "collapseOne"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("    Email ")
const _hoisted_12 = {
  id: "collapseOne",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingOne",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_13 = { class: "accordion-body" }
const _hoisted_14 = { class: "row mb-5" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Título", -1)
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "Subject" }, "Assunto", -1)
const _hoisted_19 = { class: "col-sm-12 mt-2 mb-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "Mesage" }, "Mensagem", -1)
const _hoisted_21 = { class: "accordion-item" }
const _hoisted_22 = {
  class: "accordion-header",
  id: "headingTwo"
}
const _hoisted_23 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseTwo",
  "aria-expanded": "false",
  "aria-controls": "collapseTwo"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("   Ação ")
const _hoisted_25 = {
  id: "collapseTwo",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingTwo",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_26 = { class: "accordion-body" }
const _hoisted_27 = { class: "row g-3" }
const _hoisted_28 = { class: "col-auto" }
const _hoisted_29 = { class: "form-check" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "condicional1"
}, " Email Sequêncial ", -1)
const _hoisted_31 = { class: "col-auto" }
const _hoisted_32 = { class: "form-check" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault2"
}, " Email Condicional ", -1)
const _hoisted_34 = { class: "border p-4" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" O ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" será enviado se satisfeito a condição de leitura ou click conforme configuração abaixo. Caso não seja, e claro, é opcional, um outro email pode ser apontado para o fluxo continuar.")
const _hoisted_38 = { class: "col-auto" }
const _hoisted_39 = { class: "mb-3 mt-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", null, "Tipo de Ação a ser verificado", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, " Nenhum ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, " Leitura ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, " Click ", -1)
const _hoisted_44 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-auto" }
const _hoisted_47 = { class: "mb-3 mt-3" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Email a ser verificado a ação para o dispara do email ")
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "mb-3 mt-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, " Email a ser disparado se a condição acima não for satisfeita", -1)
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "accordion-item" }
const _hoisted_54 = {
  class: "accordion-header",
  id: "headingThree"
}
const _hoisted_55 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseThree",
  "aria-expanded": "false",
  "aria-controls": "collapseThree"
}
const _hoisted_56 = /*#__PURE__*/_createTextVNode("    Agendamento ")
const _hoisted_57 = {
  id: "collapseThree",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingThree",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_58 = { class: "accordion-body" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-sm-3 mb-3" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "Interval" }, "Intervalo", -1)
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-sm-2" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { for: "Dia" }, "Dia", -1)
const _hoisted_66 = { class: "col-sm-2" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { for: "Hora" }, "Hora", -1)
const _hoisted_68 = { class: "col-sm-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { for: "Minuto" }, "Minuto", -1)
const _hoisted_70 = { class: "row mt-3" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { for: "Restrição" }, "Restrição", -1)
const _hoisted_72 = { class: "col-sm-12 mt-3 border" }
const _hoisted_73 = { class: "form-check form-check-inline" }
const _hoisted_74 = ["value"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Dom"
}, "Dom", -1)
const _hoisted_76 = { class: "form-check form-check-inline" }
const _hoisted_77 = ["value"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Seg"
}, "Seg", -1)
const _hoisted_79 = { class: "form-check form-check-inline" }
const _hoisted_80 = ["value"]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Ter"
}, "Ter", -1)
const _hoisted_82 = { class: "form-check form-check-inline" }
const _hoisted_83 = ["value"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Qua"
}, "Qua", -1)
const _hoisted_85 = { class: "form-check form-check-inline" }
const _hoisted_86 = ["value"]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Qui"
}, "Qui", -1)
const _hoisted_88 = { class: "form-check form-check-inline" }
const _hoisted_89 = ["value"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Sex"
}, "Sex", -1)
const _hoisted_91 = { class: "form-check form-check-inline" }
const _hoisted_92 = ["value"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Sab"
}, "Sab", -1)
const _hoisted_94 = { class: "mb-3 mt-3" }
const _hoisted_95 = { class: "btn btn-outline-secondary" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" Criar")
const _hoisted_97 = { class: "mt-3 mb-3" }
const _hoisted_98 = { class: "mb-3 text-center" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 text-center" }, " Email criado com sucesso! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "can-cancel": true,
        "on-cancel": $setup.onCancel,
        "is-full-page": true
      }, null, 8, ["active", "on-cancel"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.fechar && $setup.fechar(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("form", {
            onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", _hoisted_9, [
                  _createElementVNode("button", _hoisted_10, [
                    _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
                    _hoisted_11
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.title) = $event)),
                          class: "form-control",
                          id: "title",
                          type: "text",
                          name: "title",
                          required: ""
                        }, null, 512), [
                          [_vModelText, $setup.data.title]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.subject) = $event)),
                          class: "form-control",
                          id: "subject",
                          type: "text",
                          name: "subject",
                          required: ""
                        }, null, 512), [
                          [_vModelText, $setup.data.subject]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_QuillEditor, {
                          content: $setup.data.mensage,
                          "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.mensage) = $event)),
                          contentType: "html",
                          toolbar: "full"
                        }, null, 8, ["content"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h2", _hoisted_22, [
                  _createElementVNode("button", _hoisted_23, [
                    _createVNode(_component_font_awesome_icon, { icon: "paper-plane" }),
                    _hoisted_24
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.condicional) = $event)),
                            class: "form-check-input",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.condwindow($setup.data.condicional))),
                            type: "radio",
                            name: "condicional",
                            value: "0",
                            title: "Vai ser disparado de acordo com o que for definido no campo Dia ou Hora ou Minuto do Agendamento",
                            id: "condicional1",
                            checked: ""
                          }, null, 512), [
                            [_vModelRadio, $setup.data.condicional]
                          ]),
                          _hoisted_30
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.condicional) = $event)),
                            class: "form-check-input",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.condwindow($setup.data.condicional))),
                            type: "radio",
                            name: "condicional",
                            value: "1",
                            title: "Vai ser disparado conforme definido no agendamento, porém vai condicionar o envio do próximo email de acordo com a ação do usuário",
                            id: "condicional2"
                          }, null, 512), [
                            [_vModelRadio, $setup.data.condicional]
                          ]),
                          _hoisted_33
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("p", null, [
                          _hoisted_36,
                          _createElementVNode("strong", null, _toDisplayString($setup.data.title), 1),
                          _hoisted_37
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.typeaction) = $event)),
                              class: "form-select",
                              id: "typeaction",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.actionwindow($setup.data.typeaction))),
                              "aria-label": "multiple select example"
                            }, _hoisted_44, 512), [
                              [_vModelSelect, $setup.data.typeaction]
                            ])
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("label", null, [
                              _hoisted_48,
                              _createElementVNode("strong", null, _toDisplayString($setup.data.title), 1)
                            ]),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.data.mailcheck) = $event)),
                              class: "form-select",
                              id: "mailcheck",
                              name: "mailcheck",
                              "aria-label": "multiple select example"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.emails, (email) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: email.id,
                                  value: email.id
                                }, _toDisplayString(email.title), 9, _hoisted_49))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, $setup.data.mailcheck]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _hoisted_51,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.data.mailnoaction) = $event)),
                              class: "form-select",
                              id: "mailnoaction",
                              name: "mailnoaction",
                              "aria-label": "multiple select example"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.emails, (email) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: email.id,
                                  value: email.id
                                }, _toDisplayString(email.title), 9, _hoisted_52))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, $setup.data.mailnoaction]
                            ])
                          ])
                        ])
                      ], 512), [
                        [_vShow, $setup.showAction]
                      ])
                    ], 512), [
                      [_vShow, $setup.showcond]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("h2", _hoisted_54, [
                  _createElementVNode("button", _hoisted_55, [
                    _createVNode(_component_font_awesome_icon, { icon: "clock" }),
                    _hoisted_56
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.data.interval) = $event)),
                          class: "form-select",
                          id: "interval",
                          name: "interval",
                          "aria-label": "multiple select example"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.intervalo, (inter) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: inter,
                              value: inter.value
                            }, _toDisplayString(inter.label), 9, _hoisted_62))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, $setup.data.interval]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _hoisted_65,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.data.qtd) = $event)),
                          class: "form-control",
                          id: "qtd",
                          type: "text",
                          name: "qtd",
                          required: ""
                        }, null, 512), [
                          [_vModelText, $setup.data.qtd]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _hoisted_67,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.data.qth) = $event)),
                          class: "form-control",
                          id: "qth",
                          type: "text",
                          name: "qth",
                          required: ""
                        }, null, 512), [
                          [_vModelText, $setup.data.qth]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.data.qtm) = $event)),
                          class: "form-control",
                          id: "qtm",
                          type: "text",
                          name: "qtm",
                          required: ""
                        }, null, 512), [
                          [_vModelText, $setup.data.qtm]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.Dom) = $event)),
                            value: `${$setup.Dom}`,
                            type: "checkbox",
                            id: "Dom"
                          }, null, 8, _hoisted_74), [
                            [_vModelCheckbox, $setup.Dom]
                          ]),
                          _hoisted_75
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.Seg) = $event)),
                            value: `${$setup.Seg}`,
                            type: "checkbox",
                            id: "Seg"
                          }, null, 8, _hoisted_77), [
                            [_vModelCheckbox, $setup.Seg]
                          ]),
                          _hoisted_78
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.Ter) = $event)),
                            value: `${$setup.Ter}`,
                            type: "checkbox",
                            id: "Ter"
                          }, null, 8, _hoisted_80), [
                            [_vModelCheckbox, $setup.Ter]
                          ]),
                          _hoisted_81
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.Qua) = $event)),
                            value: `${$setup.Qua}`,
                            type: "checkbox",
                            id: "Qua"
                          }, null, 8, _hoisted_83), [
                            [_vModelCheckbox, $setup.Qua]
                          ]),
                          _hoisted_84
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.Qui) = $event)),
                            value: `${$setup.Qui}`,
                            type: "checkbox",
                            id: "Qui"
                          }, null, 8, _hoisted_86), [
                            [_vModelCheckbox, $setup.Qui]
                          ]),
                          _hoisted_87
                        ]),
                        _createElementVNode("div", _hoisted_88, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.Sex) = $event)),
                            value: `${$setup.Sex}`,
                            type: "checkbox",
                            id: "Sex"
                          }, null, 8, _hoisted_89), [
                            [_vModelCheckbox, $setup.Sex]
                          ]),
                          _hoisted_90
                        ]),
                        _createElementVNode("div", _hoisted_91, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.Sab) = $event)),
                            value: `${$setup.Sab}`,
                            type: "checkbox",
                            id: "Sab"
                          }, null, 8, _hoisted_92), [
                            [_vModelCheckbox, $setup.Sab]
                          ]),
                          _hoisted_93
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("button", _hoisted_95, [
                _createVNode(_component_font_awesome_icon, { icon: "save" }),
                _hoisted_96
              ])
            ])
          ], 544), [
            [_vShow, !$setup.janela]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("h1", null, [
                _createVNode(_component_font_awesome_icon, { icon: "thumbs-up" })
              ])
            ]),
            _hoisted_99
          ], 512), [
            [_vShow, $setup.janela]
          ])
        ])
      ])
    ])
  ]))
}